import React from 'react';
// MUI Components
import { IconButton } from '@mui/material';

// lucide Icons
import { X, ArrowLeft } from 'lucide-react';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';

export default function GameHeader({ onClose, showClose, onBack, showBack }) {
  const { theme } = useTheme();

  return (
    <React.Fragment>
      {showBack && (
        <IconButton
          onClick={onBack}
          size="small"
          sx={{
            p: 0.5,
            position: 'absolute',
            left: 0,
            '&:hover': { backgroundColor: theme.background.secondary },
            ml: 1.5,
          }}
          aria-label="Back"
        >
          <ArrowLeft fontSize="medium" />
        </IconButton>
      )}
      {showClose && (
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: theme.text.tertiary,
            p: 0.5,
            position: 'absolute',
            right: 0,
            top: 0,
            zIndex: 2,
            '&:hover': {
              backgroundColor: theme.background.secondary,
              color: theme.text.primary
            },
            mr: 1.5,
            mt: 1,
          }}
          aria-label="Close"
        >
          <X fontSize="medium" />
        </IconButton>
      )}
    </React.Fragment>
  );
}
